import React from 'react';

import css from './button.module.scss';

interface Props {
  text: string;
  secondary?: boolean;
  outline?: boolean;
  inverted?: boolean;
  destructive?: boolean;
  disabled?: boolean;
  loading?: boolean;
  'data-e2e'?: string;
  'data-testid'?: string;
  onClick?: () => void;
  plan?: string;
}

const Button = ({
  text,
  secondary = false,
  outline = false,
  inverted,
  destructive = false,
  disabled,
  loading,
  onClick,
  ...props
}: Props) => {
  let buttonStyle;
  if (secondary) {
    buttonStyle = css.secondaryButton;
  } else if (destructive) {
    buttonStyle = css.destructiveButton;
  } else if (outline) {
    buttonStyle = css.outlineButton;
  } else {
    buttonStyle = inverted ? css.invertedButton : css.button;
  }

  return (
    <button
      data-e2e={props['data-e2e'] ? props['data-e2e'] : 'button'}
      data-e2e-name={`${text.toLowerCase().split(' ').join('')}`}
      data-testid={props['data-testid']}
      className={`${buttonStyle} ${css.button}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <span>{loading ? <div className={css.loading} /> : text}</span>
    </button>
  );
};

export default Button;
